import { render, staticRenderFns } from "./NotFoundComponent.vue?vue&type=template&id=c994bd6e&scoped=true&lang=pug&"
import script from "./NotFoundComponent.vue?vue&type=script&lang=js&"
export * from "./NotFoundComponent.vue?vue&type=script&lang=js&"
import style0 from "./NotFoundComponent.scss?vue&type=style&index=0&id=c994bd6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c994bd6e",
  null
  
)

export default component.exports